import layoutHeaderAside from '@/layout/header-aside'
const files = require.context('./', true, /\.js$/)

let componentMaps = {
  'layoutHeaderAside': layoutHeaderAside,
  'monitorManager': () => import('@/pages/index/gov'),
  'workbreanchManager': () => import('@/pages/index'),
  'serviceManager': () => import('@/pages/auth/service/index'),
  'userManager': () => import('@/pages/admin/user'),
  'groupManager': () => import('@/pages/admin/group'),
  'menuManager': () => import('@/pages/admin/menu'),
  'gateLogManager': () => import('@/pages/admin/gateLog'),
  'groupTypeManager': () => import('@/pages/admin/groupType'),
  'devFormManager': () => import('@/pages/dev/build'),
  'codeManager': () => import('@/pages/dev/code'),
  'onlineManager': () => import('@/pages/admin/online'),

  'govManager': () => import('@/pages/admin/sysGov'),
  'enterpriseManager': () => import('@/pages/admin/sysEnterprise'),
  'entAuditManager': () => import('@/pages/admin/sysEnterprise/openAudit'),
  'devManager': () => import('@/pages/admin/sysDevApp'),
  'enterpriseAuthManager': () => import('@/pages/admin/sysEnterpriseAuth'),
  'materialAuditManager': () => import('@/pages/admin/sysEnterpriseMaterial'),
  'signatureManager': () => import('@/pages/admin/sysEnterpriseSignature'),
  'signatureAuditManager': () => import('@/pages/admin/sysEnterpriseSignature/audit.vue'),
  'materialReviewManager': () => import('@/pages/admin/sysEnterpriseMaterial/review.vue'),
  'consignmentManager': () => import('@/pages/admin/sysConsignment/index.vue'),

  'townManager': () => import('@/pages/admin/common/town.vue'),
  'materialAuth': () => import('@/pages/admin/common/materialAuth.vue'),
  'materialManager': () => import('@/pages/admin/common/material.vue'),
  'oilManager': () => import('@/pages/admin/common/oilList.vue'),
  'inrecordManager': () => import('@/pages/admin/common/oilInrecord.vue'),
  'truckinManager': () => import('@/pages/admin/common/truckIn.vue'),
  'truckoilManager': () => import('@/pages/admin/common/truckoil.vue'),

  'reportManage': () => import('@/pages/admin/report/report1.vue'),
  'alarmTruckNo': () => import('@/pages/admin/alarm/truckNo'),
  'repeatOilManager': () => import('@/pages/admin/alarm/repeatOil'),
  'superviseOilManager': () => import('@/pages/admin/alarm/superviseOil'),
  'totalCardManager': () => import('@/pages/admin/alarm/totalCard'),
  'volumeEdeManager': () => import('@/pages/admin/alarm/volumeEde'),
  'wrongCardManager': () => import('@/pages/admin/alarm/wrongCard'),
  'registerCarManager': () => import('@/pages/admin/sysCarMeta'), 
  'driverManager': () => import('@/pages/admin/appCarDriver'),
  'carModelManager': () => import('@/pages/admin/sysCarModel')
 }
files.keys().forEach((key) => {
  if (key === './index.js') return
  Object.assign(componentMaps, files(key).default)
})
export default componentMaps
